import { Routes, Route, Navigate } from 'react-router-dom'
import { QuizModeProvider } from '@quebon/shared-learning'
import { useAuthStore } from '@/store/authStore'
import { Layout } from '@/components/layout/Layout'
import { HomePage } from '@/pages/home/HomePage'
import { LoginPage } from '@/pages/auth/LoginPage'
import { RegisterPage } from '@/pages/auth/RegisterPage'
import { LandingPage } from '@/pages/landing/LandingPage'
import { LearnPage } from '@/pages/learn/LearnPage'
import { CurriculumDetailPage } from '@/pages/learn/CurriculumDetailPage'
import { CourseDetailPage } from '@/pages/learn/CourseDetailPage'
import { LessonPage } from '@/pages/learn/LessonPage'
import { QueturePage } from '@/pages/learn/QueturePage'
import { CheckoutPage } from '@/pages/checkout/CheckoutPage'
import { SubscriptionSuccessPage } from '@/pages/checkout/SubscriptionSuccessPage'
import { SubscriptionPlansPage } from '@/pages/subscription/SubscriptionPlansPage'
import { ProductsPage } from '@/pages/products/ProductsPage'
import { ProductDetailPage } from '@/pages/products/ProductDetailPage'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { SubscriptionRoute } from '@/components/auth/SubscriptionRoute'
import { AdminLayout } from '@/pages/admin/AdminLayout'
import { AdminDashboard } from '@/pages/admin/AdminDashboard'
import { UserManagement } from '@/pages/admin/UserManagement'
import { SubscriptionManagement } from '@/pages/admin/SubscriptionManagement'
import { ProductManagement } from '@/pages/admin/ProductManagement'
import { ContentManagement } from '@/pages/admin/ContentManagement'
import AiqReport from '@/pages/learner/aiq/AiqReport'

// Public Only Route - 로그인 상태에서 접근 시 메인으로 리다이렉트
function PublicOnlyRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuthStore()

  if (isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

function App() {
  return (
    <QuizModeProvider value={{ mode: 'student' }}>
    <Routes>
      {/* Public Routes - 로그인 없이 접근 가능 */}
      <Route path="/landing" element={<LandingPage />} />
      <Route path="/login" element={<PublicOnlyRoute><LoginPage /></PublicOnlyRoute>} />
      <Route path="/register" element={<RegisterPage />} />

      {/* Public Routes with Layout - 로그인 없이 접근 가능 */}
      <Route element={<Layout />}>
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:productId" element={<ProductDetailPage />} />
      </Route>

      {/* Protected Routes - 로그인만 필요 */}
      <Route element={<ProtectedRoute />}>
        {/* 구독 관련 페이지 - Layout 포함 (헤더 표시) */}
        <Route element={<Layout />}>
          <Route path="/subscription/plans" element={<SubscriptionPlansPage />} />
        </Route>
        <Route path="/checkout/:productId" element={<CheckoutPage />} />
        <Route path="/subscription/success" element={<SubscriptionSuccessPage />} />

        {/* 구독이 필요한 학습 페이지들 */}
        <Route element={<SubscriptionRoute />}>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/learn" element={<LearnPage />} />
            <Route path="/learn/curriculum/:curriculumId" element={<CurriculumDetailPage />} />
            <Route path="/learn/course/:courseId" element={<CourseDetailPage />} />
            <Route path="/learn/lesson/:lessonId" element={<LessonPage />} />
            <Route path="/learn/queture/:qid" element={<QueturePage />} />
            <Route path="/learn/aiq-report/:productId" element={<AiqReport />} />
            <Route path="/profile" element={<div>Profile Page</div>} />
          </Route>
        </Route>

        {/* Admin Routes - 관리자 권한 필요 */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="users" element={<UserManagement />} />
          <Route path="subscriptions" element={<SubscriptionManagement />} />
          <Route path="products" element={<ProductManagement />} />
          <Route path="contents" element={<ContentManagement />} />
        </Route>
      </Route>

      {/* 404 */}
      <Route path="*" element={<div>404 - Page Not Found</div>} />
    </Routes>
    </QuizModeProvider>
  )
}

export default App
